import UniverseStability from './components/UniverseStability.vue'

export default UniverseStability



// WEBPACK FOOTER //
// ./src/app/appComponents/workbench/lasGraphs/universeStability/index.js